// KABULAYR.GRUPKOD -> zemin rengi. Eski VB6 uygulamasındaki &H..BBGGRR renk sabitleri BGR sırasıyla
// tanımlıydı; burada CSS'in beklediği #RRGGBB sırasına çevrilmiş halleri kullanılıyor. Kabul
// İşlemleri ve Fiyat Ver ekranlarında hizmet satırları için ortak kullanılır.
export const grupRenkleri = {
  1: '#F8F881',
  2: '#C0FFC0',
  3: '#FFC0FF',
  4: '#F2D777',
  5: '#C0FFFF',
  6: '#D2DFE6',
  7: '#DCBDE1',
  8: '#FF8080',
  9: '#92C0FA',
  10: '#C7D962',
};

// Stok kaynaklı satırların sabit zemin rengi (VB6: &H00C0E0FF&) — kullanıcı talebi: 2026-08-09.
export const stokRengi = '#FFE0C0';
